import { render, staticRenderFns } from "./InformList.vue?vue&type=template&id=56ad77a8&scoped=true"
import script from "./InformList.vue?vue&type=script&lang=js"
export * from "./InformList.vue?vue&type=script&lang=js"
import style0 from "./InformList.vue?vue&type=style&index=0&id=56ad77a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ad77a8",
  null
  
)

export default component.exports